import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import logger from 'redux-logger';
import _ from 'lodash';

import { Corner, WindowState } from '$root/utils/enums';
import { initialState } from './initialState';
import {
    SET_AVAILABLE_PLANS,
    SET_AVAILABLE_PROJECTS,
    SET_DARK_MODE,
    SET_PLANVIEW_POSITION,
    SET_PLANVIEW_STATE,
    SET_PROJECT_SELECT_VISIBLE,
    SET_SELECTED_PLAN,
    SET_SELECTED_VIEWPOINT,
    SET_SELECTED_PROJECT,
    SET_PLAN_VISIBLE_LAYERS,
    SET_LEFT_YAW,
    SET_LEFT_PITCH,
    SET_LEFT_HFOV,
    SET_SPLIT_VIEW,
    SET_TAG_LEGENDS_VISIBLE
} from './actions';


const saveToLocalStorage = (state) => {
    try {

        let savedState = {
            ui: {
                darkMode: state.ui.darkMode,
                tagsLegendVisible: state.ui.tagsLegendVisible,
                planView : {
                    state: (state.ui.planView.state === WindowState.MAXIMIZED ? WindowState.NORMAL : state.ui.planView.state),
                    position: state.ui.planView.position,
                    width: state.ui.planView.width,
                    height: state.ui.planView.height,
                }
            }
        };

        localStorage.setItem('BIMlens.State', JSON.stringify(savedState));
    }
    catch (e) {
        console.error('here', e);
    }
};


const loadFromLocalStorage = (initial = initialState) => {
    try {
        const stateStr = localStorage.getItem('BIMlens.State');

        let result = {...initial};
        if (stateStr) {
            const savedState = JSON.parse(stateStr);

            _.has(savedState, 'ui.darkMode') && (result.ui.darkMode = savedState.ui.darkMode);
            _.has(savedState, 'ui.tagsLegendVisible') && (result.ui.tagsLegendVisible = savedState.ui.tagsLegendVisible);
            _.has(savedState, 'ui.planView.state') && (result.ui.planView.state = savedState.ui.planView.state);
            _.has(savedState, 'ui.planView.position') && (result.ui.planView.position = savedState.ui.planView.position);
            _.has(savedState, 'ui.planView.width') && (result.ui.planView.width = savedState.ui.planView.width);
            _.has(savedState, 'ui.planView.height') && (result.ui.planView.height = savedState.ui.planView.height);
        }

        return result;
    }
    catch (e) {
        console.error('there', e);
    }

    return initial
};


const reducer = (state = loadFromLocalStorage(), action) => {

    switch (action.type) {
    case SET_AVAILABLE_PROJECTS:
        return {
            ...state,
            project: {
                ...state.project,
                availableProjects:action.payload,
            }
        };

    case SET_SELECTED_PROJECT:
        return {
            ...state,
            project: {
                ...state.project,
                selectedProjectId: action.payload.id,
                selectedProject:action.payload,
            }
        };

    case SET_AVAILABLE_PLANS:
        return {
            ...state,
            project: {
                ...state.project,
                availablePlans:action.payload,
            }
        };

    case SET_SELECTED_VIEWPOINT:
        return {
            ...state,
            project: {
                ...state.project,
                selectedViewpointId:action.payload,
            }
        };

    case SET_SPLIT_VIEW:
        return {
            ...state,
            project: {
                ...state.project,
                splitView:action.payload,
            }
        };

    case SET_TAG_LEGENDS_VISIBLE:
        return {
            ...state,
            ui: {
                ...state.ui,
                tagsLegendVisible:action.payload,
            }
        };

    case SET_LEFT_YAW:
        return {
            ...state,
            project: {
                ...state.project,
                leftYaw:action.payload,
            }
        };

    case SET_LEFT_PITCH:
        return {
            ...state,
            project: {
                ...state.project,
                leftPitch:action.payload,
            }
        };

    case SET_LEFT_HFOV:
        return {
            ...state,
            project: {
                ...state.project,
                leftHfov:action.payload,
            }
        };

    case SET_SELECTED_PLAN:
        return {
            ...state,
            project: {
                ...state.project,
                selectedPlan:action.payload,
            }
        };

    case SET_PLAN_VISIBLE_LAYERS:
        return {
            ...state,
            project: {
                ...state.project,
                planVisibleLayers:action.payload,
            }
        };

    case SET_PROJECT_SELECT_VISIBLE:
        return {
            ...state,
            ui: {
                ...state.ui,
                projectSelectVisible:action.payload,
            }
        };

    case SET_DARK_MODE:
        return {
            ...state,
            ui: {
                ...state.ui,
                darkMode:action.payload,
            }
        };

    case SET_PLANVIEW_POSITION:
        return {
            ...state,
            ui: {
                ...state.ui,
                planView: {
                    ...state.ui.planView,
                    position:action.payload,
                },
            }
        };

    case SET_PLANVIEW_STATE:
        return {
            ...state,
            ui: {
                ...state.ui,
                planView: {
                    ...state.ui.planView,
                    state:action.payload,
                },
            }
        };
    }

    return state;
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(reducer, composeEnhancers(applyMiddleware(
    reduxThunk,
    // logger
)));


store.subscribe(() => { saveToLocalStorage(store.getState()) })
